import { render, staticRenderFns } from "./OpenTicket.vue?vue&type=template&id=7b56da26"
import script from "./OpenTicket.vue?vue&type=script&lang=js"
export * from "./OpenTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b56da26')) {
      api.createRecord('7b56da26', component.options)
    } else {
      api.reload('7b56da26', component.options)
    }
    module.hot.accept("./OpenTicket.vue?vue&type=template&id=7b56da26", function () {
      api.rerender('7b56da26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/management/ticket/pages/ticket/OpenTicket.vue"
export default component.exports